import config from 'config';
import Image from 'next/image';

import { Box, useBreakpointValue } from '@chakra-ui/react';

import { Link } from 'ui';

const {
  iconLogo: IconLogo,
  logo: logoRaster,
  logoLink,
  isExternalLink,
  isSquareIcon,
  isFullColorLogo
} = config;

const Logo = () => {
  const logoHeight = useBreakpointValue({ base: '46px', md: '75px' });
  const logoWidth = useBreakpointValue({ base: '300px', sm: 'auto' });

  /** Raster header mark avoids SVGR/layout issues for multi-color artwork (KHC). */
  if (isFullColorLogo && logoRaster) {
    return (
      <Link to={logoLink} external={isExternalLink}>
        <Box lineHeight={0} maxW='100%'>
          <Image
            src={logoRaster}
            alt=''
            width={logoRaster.width}
            height={logoRaster.height}
            sizes='(max-width: 768px) 60vw, 360px'
            style={{
              display: 'block',
              height: logoHeight,
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain'
            }}
            priority
          />
        </Box>
      </Link>
    );
  }

  return (
    <Link to={logoLink} external={isExternalLink}>
      <Box>
        {isSquareIcon ? (
          <IconLogo
            style={{
              height: logoHeight,
              width: logoWidth
            }}
          />
        ) : (
          <IconLogo style={{ maxHeight: logoHeight, maxWidth: logoWidth }} />
        )}
      </Box>
    </Link>
  );
};

export default Logo;
